import type { TWarehouseTaskType } from 'api/swagger';

export const WHTaskType: Record<TWarehouseTaskType, TWarehouseTaskType> = {
  storing: 'storing',
  reloading: 'reloading',
};
